import React from 'react';
import { useDebug } from './debug-provider';
import DebugPill from './debug-pill';

type DraftDebugProps = {
    publishedAt?: string | null
};

const DraftDebug = ({ publishedAt }: DraftDebugProps): JSX.Element | null => {
    const { showCurrentPublishState } = useDebug();
    if (showCurrentPublishState) {
        return (
            <DebugPill>
                {publishedAt ? `Published ${publishedAt}` : 'Not Published'}
            </DebugPill>
        );
    }

    return null;
};

export default DraftDebug;
